import React from 'react';
import { useRepeatedSlotPlaceholder } from '../hooks/useRepeatedSlotPlaceholder';
export const RepeatedSlotsPlaceholder = (props) => {
    const { getRepeatedItem } = useRepeatedSlotPlaceholder(props.slotId);
    const [Placeholder] = getRepeatedItem(props.repeatedItemId);
    return React.createElement(Placeholder, null);
};
//# sourceMappingURL=RepeatedSlotsPlaceholder.js.map